import React, { useContext, useEffect, useState } from 'react';
import classes from './adminLogs.module.scss'
import { useQuery } from '../../hooks/useQuery';
import { getAdminDataRequest } from '../../httpRequests/consoleRequests';
import IAdmin, { ILobby } from '../../interfaces/admin';
import { CONSOLE_URL, CONSOLE_URL_ASIA, CONSOLE_URL_EU, CONSOLE_URL_US } from '../../consts/config';
import { AdminDataVM } from '../admin/admin';
import classNames from 'classnames';

interface AdminDataLogsVM  {
  onlinePlayers: {
    eu?: number,
    us?: number,
    asia?: number
  }
  activeLobbys: {
    eu?: number,
    us?: number,
    asia?: number
  },
  activeGames: {
    eu?: number,
    us?: number,
    asia?: number
  },
  lobbyData: Array< ILobby>
  history: Array< ILobby>

}
const getApi = (region: string) => {
  switch(region) {
    case 'asia':
      return CONSOLE_URL_ASIA
    case 'eu':
      return CONSOLE_URL_EU
    case 'us': 
      return CONSOLE_URL_US
    default: 
      return CONSOLE_URL_US
  }
}
function AdminLogsContainer() {
  const [logs, setLogs] = useState<Array<string>>([])
  //@ts-ignore
  const query = useQuery() as {region: string, roomNumber: string, history: string, gameIndex?: number}
  useEffect(() => {
      // @ts-ignore
    getAdminData( query.admin)
  }, [])
   const getAdminData = async (admin : string) => {
    const adminData = await getAdminDataRequest(admin, getApi(query.region))
    let logs : Array<string> | undefined = []
    if(query.history === "true") {
      if(query.gameIndex) {
        logs = adminData.history.find(lobby => lobby.roomNumber === query.roomNumber)?.gamesPlayed[query.gameIndex].logs
      } else {
        logs = adminData.history.find(lobby => lobby.roomNumber === query.roomNumber)?.logs
      }
    } else {
      if(query.gameIndex) {
        logs = adminData.lobbyData.find(lobby => lobby.roomNumber === query.roomNumber)?.gamesPlayed[query.gameIndex].logs
      } else {
        logs = adminData.lobbyData.find(lobby => lobby.roomNumber === query.roomNumber)?.logs
      }
    }
    if(logs) {
      setLogs(logs)
    }
   }

   if(!logs) {
     return null
   }
   const importantLogs = ['Pong received', 'Admin changing game', 'Lobby game ready','Room Number:', "Change changed", 'Game socket disconnected', "Host selected a game", "Javascript finished loading", "created a lobby", "Finished loading Games", "Loading games for the lobby"]
  return (
    <div className={ classes.wrapper}>
      {
        logs.map((log,index) => { 
          const isImportantMessage = importantLogs.some(importantLog => log.includes(importantLog))
          return (<div className={classes.log}> 
            <div className={classes.number}> {index}.</div> <div className={classNames(classes.logLine, {[classes.important]: isImportantMessage})}>{log}</div>
          </div>) 
          })
      }
  </div>  
    
  );
}

export default AdminLogsContainer;
